import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouteAccessCheck } from '../../../../app/Hoc/WithLoginAceessCheck';
import CreateMessage from '../MyAccount/message/createMessage.jsx';
import MessageForCentricUser from '../MyAccount/message/messageForCentricUser';
import { capitalize } from '../../../../app/utils/utils';
import IconButton from '@mui/material/IconButton';
import {
  createMessageCase,
  getMessageList,
  clearSuccessMessage
} from '../../../../app/redux/slices/app/messageSlice';
import MessageLoader from '../MyAccount/message/messageLoader.jsx';
import Collapse from '@mui/material/Collapse';
import { Drawer, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CustomSnackbar from '../../../../features/components/customComponents/CustomSnackbar/index';
import { CircularProgress } from '@mui/material';
import { formatDate } from '../../../../features/utils/utils';
import { UserTypes } from '../../../../features/constants/commonEnum';

const GasMessageCenter = () => {
  const dispatch = useDispatch();

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [expandedMessageId, setExpandedMessageId] = useState(null);

  const handleToggleExpand = messageId => {
    setExpandedMessageId(expandedMessageId === messageId ? null : messageId);
  };

  const { userAccountDetails } = useSelector(state => state?.userDetailSlice);
  const [searchText, SetSearchText] = useState('');

  const createMessageCommentData = useSelector(
    state => state.messageSlice.createMessageCommentData
  );
  const createCaseMessageData = useSelector(state => state.messageSlice.createCaseMessageData);

  const messageList = useSelector(state => state.messageSlice.messageList);

  const [searchList, setSearchList] = useState(
    useSelector(state => state.messageSlice.messageList?.data)
  );

  useEffect(() => {
    setSearchList(messageList?.data);
  }, [messageList]);

  useEffect(() => {
    if (createCaseMessageData.successMessage || createMessageCommentData.successMessage) {
      setOpenSnackbar(true);
    }
  }, [createCaseMessageData, createMessageCommentData]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState({
    case_id: '',
    comment: ''
  });

  const [page, setPage] = useState({
    totalCount: 50,
    currentPage: 1,
    pageCount: 3,
    itemsPerPage: 20
  });
  const onOpenModal = () => {
    setModalOpen(true);
  };
  const selectedAccount = useSelector(state => state?.userDetailSlice?.selectedAccount);

  useEffect(() => {
    if (selectedAccount) {
      dispatch(
        getMessageList({
          crm_contact_id: userAccountDetails?.userAccountInfo?.crm_contact_id,
          case_id: ''
        })
      );
    }
  }, [!modalOpen]);

  const btnSubmit = caseId => {
    dispatch(createMessageCase({ ...value })).then(() => {
      dispatch(getMessageList(userAccountDetails?.userAccountInfo?.crm_contact_id));
    });
  };
  const btnSearch = () => {
    if (searchText === '') {
      setSearchList(messageList.data);
    } else {
      const searchedList = messageList.data.filter(
        a => a.title.includes(searchText) || a.description.includes(searchText)
      );
      setSearchList(searchedList);
    }
  };

  const successMessage =
    createCaseMessageData.successMessage || createMessageCommentData.successMessage;

  return (
    <>
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={successMessage.includes('Failed') ? 'error' : 'success'}
        message={successMessage}
        autoHideDuration={1000}
        handleClose={() => {
          setOpenSnackbar(false);
          dispatch(clearSuccessMessage());
        }}
      />
      <CreateMessage setModalOpen={setModalOpen} modalOpen={modalOpen} />
      {userAccountDetails?.userAccountInfo?.userTypeCode === UserTypes.CENTRIC ? (
        <MessageForCentricUser />
      ) : (
        <>
          <div className="row min-h-100 justify-content-center">
            <div className="col-xxl-12">
              <div className="card card-custom card-xxl-stretch message-box-card">
                <div className="card-body">
                  <div className="mb-5 d-flex justify-content-between align-items-stretch with_hr_tabs gap-10px">
                    <div className="custom-search">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by Topic/Title"
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                          id="searchInput"
                          onChange={e => {
                            e.preventDefault();
                            SetSearchText(e.target.value);
                          }}
                        />
                        <span
                          onClick={e => {
                            e.preventDefault();
                            btnSearch();
                          }}
                          className="input-group-text"
                          id="basic-addon1"
                        >
                          <i className="fa-regular fa-magnifying-glass"></i>
                        </span>
                      </div>
                    </div>
                    <div className="head_btn align-items-center d-flex gap-10px">
                      <button
                        onClick={e => {
                          e.preventDefault();
                          onOpenModal();
                        }}
                        className="btn btn-custom electric_cobalt min-h-55px"
                      >
                        + New Message
                      </button>
                    </div>
                  </div>
                  <div className="card-body-content">
                    <div className="d-flex flex-column gap-10px">
                      {messageList.loader ? (
                        <>
                          <MessageLoader />
                        </>
                      ) : (
                        searchList?.map((item, index) => (
                          <div key={index} className="message">
                            <div className="subject"> {capitalize(item?.title)}</div>
                            <div className="text">{item.description}</div>
                            <div className="time">
                              {new Date(item.created_date).toLocaleDateString()}
                            </div>

                            <div className="card card-custom comments">
                              <div className="card-header min-h-1px cp">
                                <p
                                  className={
                                    expandedMessageId === item.case_no
                                      ? 'text-blue m-0'
                                      : 'text-light'
                                  }
                                  onClick={() => handleToggleExpand(item.case_no)}
                                >
                                  <i className="fa-sharp fa-solid fa-comment me-1"></i>
                                  {item.messageComments.length} Comments
                                </p>
                              </div>

                              <Collapse
                                in={expandedMessageId === item.case_no ? true : false}
                                timeout="auto"
                                unmountOnExit
                              >
                                <div className="card-body">
                                  {item.messageComments &&
                                    Object.values(item.messageComments)
                                      .sort(
                                        (a, b) =>
                                          new Date(b.created_date) - new Date(a.created_date)
                                      )
                                      .slice(0, 2)
                                      .map((item, index) => (
                                        <>
                                          <div className="message readed">
                                            <div className="d-flex justify-content-between align-items-start">
                                              <div className="subject">{item.comments}</div>
                                              <div className="time">
                                                {new Date(item.created_date).toLocaleDateString() +
                                                  ', ' +
                                                  new Date(item.created_date).toLocaleTimeString()}
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      ))}
                                </div>
                                {item?.messageComments?.length > 2 && (
                                  <div className="card-footer text-center border-bottom">
                                    <a
                                      onClick={() => {
                                        setOpen(true);
                                        setSelectedItem(item);
                                      }}
                                      href="javascript:void(0);"
                                    >
                                      View All
                                    </a>
                                  </div>
                                )}

                                <div className="comment p-3">
                                  <div className="form-group">
                                    <textarea
                                      className="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      placeholder="Add New Comment Here..."
                                      onChange={e => {
                                        e.preventDefault();
                                        setValue({
                                          comment: e.target.value,
                                          case_id: item.case_id
                                        });
                                      }}
                                    ></textarea>
                                  </div>
                                  <div className="text-end">
                                    <button
                                      className="btn btn-custom electric_cobalt"
                                      onClick={e => {
                                        e.preventDefault();
                                        btnSubmit(item.contact_id);
                                      }}
                                    >
                                      {createMessageCommentData?.loader ? (
                                        <CircularProgress size={22} />
                                      ) : (
                                        'Submit'
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </Collapse>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Drawer
            anchor="right"
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
              sx: { width: '40vw', padding: 2, color: 'white' }
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6">Message Details</Typography>
              <IconButton onClick={() => setOpen(false)} sx={{ color: 'white' }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <div className="card card-custom card-xxl-stretch message-box-card">
              <div className="card-body">
                <div className="card-body-content">
                  <div className="d-flex flex-column gap-10px">
                    <div className="message">
                      <div className="subject"> {capitalize(selectedItem?.title)}</div>
                      <div className="text">{selectedItem.description}</div>
                      <div className="time">
                        {new Date(selectedItem.created_date).toLocaleDateString()}
                      </div>

                      <div className="card card-custom comments">
                        <div className="card-header min-h-1px cp">
                          <p
                            className={
                              expandedMessageId === selectedItem.case_no
                                ? 'text-blue m-0'
                                : 'text-light'
                            }
                            onClick={() => handleToggleExpand(selectedItem.case_no)}
                          >
                            <i className="fa-sharp fa-solid fa-comment me-1"></i>
                            Comments
                          </p>
                        </div>

                        <div className="card-body">
                          {selectedItem.messageComments &&
                            Object.values(selectedItem.messageComments)
                              .sort((a, b) => new Date(b.created_date) - new Date(a.created_date))

                              .map((selectedItem, index) => (
                                <>
                                  <div className="message readed">
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div className="subject">{selectedItem.comments}</div>
                                      <div className="time">
                                        {formatDate(selectedItem.created_date) +
                                          ', ' +
                                          new Date(selectedItem.created_date).toLocaleTimeString()}
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ))}
                        </div>

                        <div className="comment p-3">
                          <div className="form-group">
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              placeholder="Add New Comment Here..."
                              onChange={e => {
                                e.preventDefault();
                                setValue({
                                  comment: e.target.value,
                                  case_id: selectedItem.case_id
                                });
                              }}
                            ></textarea>
                          </div>
                          <div className="text-end">
                            <button
                              className="btn btn-custom electric_cobalt"
                              onClick={e => {
                                e.preventDefault();
                                btnSubmit(selectedItem.contact_id);
                                setOpen(false);
                                setSelectedItem({});
                              }}
                            >
                              {createCaseMessageData?.loader ? (
                                <CircularProgress size={22} />
                              ) : (
                                'Submit'
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Drawer>
        </>
      )}
    </>
  );
};
export default withRouteAccessCheck(GasMessageCenter);
